import HalfCircleDonatChart from './half-circle-donat-chart';

export default HalfCircleDonatChart;
